<template>
  <div class="bg">
    <div class="title-container">
      <div class="title">
        <!-- <img src="../assets/Starting/img-map/logo.png" /> -->
      {{title}}</div>
    </div>
    <div class="newslistbox">
      <div class="map" id="chinaMap"><nationalMapChart /></div>
    </div>
  </div>
</template>

<script>
import nationalMapChart from "@/components/echart/nationalMap/nationalMapChart";
// import { getMap } from "../api/re";
export default {
  components: {
    nationalMapChart,
  },
  data() {
    return {
      title: "全国交通热点",
    };
  },
  created() {

    // this.lond();
  },

  methods: {
    // lond() {
    //   getMap({
    //     city: this.city,
    //   }).then((res) => {
    //     console.log(res);
    //   });
    // },
    goDetail(e) {
      window.location.href = e;
    },

  },
};
</script>

<style lang="scss" scoped>
::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}
.bg {
  width: 100vw;
  height: 100vh;
  background: url("../assets/Starting/img-map/wnmq.png");
  background-size: 100% 100%;
  overflow: hidden;
  .title-container {
    height: 12vh;
    .title {
      color: #ffffff;
      font-weight: bold;
      font-size: 2vw;
      width: 19%;
      height: 12vh;
    line-height: 12vh;
      margin-left: 2.3%;
      overflow: hidden;
      text-align: center;
      text-overflow: ellipsis;
      white-space: nowrap;
      img {
        vertical-align: middle;
        width: 13%;
        height: 5.2vh;
        margin-right: 3.2%;
      }
    }
  }
  .newslistbox {
    width: calc(100% - 4.58vw);
    height: 90vh;
    font-size: 3vh;
    position: absolute;
    top: 12.99vh;
    margin: 0 2.29vw;
    .map {
      width: 61.98vw;
      height: 81.5vh;
      margin-left: 50px;
    }
   
    .showlist {
      .mapNewsList:nth-child(n) {
        // opacity: 1;
        transform: translate(0, 0);
        -webkit-transform: translate(0, 0);
      }
    }
  }
}
</style>
